import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {SidebarComponent} from './sidebar.component';


const routes: Routes = [
  {
      path: '',
      component: SidebarComponent,
      children: [
          { path: '', redirectTo: 'dashboard', pathMatch: 'prefix' },
          { path: 'blank-page', loadChildren: '../../blank-page/blank-page.module#BlankPageModule' },
          { path: 'forms', loadChildren: '../../encs/form/form.module#FormModule' },
      ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SidebarRoutingModule { }
